import { AlertTriangle } from "lucide-react";

export default function DisclaimerBanner({ compact = false }) {
  if (compact) {
    return (
      <div
        data-testid="medical-disclaimer-pill"
        className="inline-flex items-center gap-1.5 rounded-full bg-amber-950/50 border border-amber-600/40 px-3 py-1 text-[11px] font-mono uppercase tracking-wider text-amber-300"
      >
        <AlertTriangle className="h-3 w-3" />
        Not medical advice
      </div>
    );
  }
  return (
    <div
      data-testid="medical-disclaimer-banner"
      className="flex items-start gap-3.5 rounded-xl bg-amber-950/40 border border-amber-600/50 p-4 sm:p-5 my-6 text-amber-200 text-sm leading-relaxed shadow-lg shadow-amber-950/20"
    >
      <AlertTriangle className="h-5 w-5 shrink-0 mt-0.5 text-amber-400" />
      <p>
        <span className="font-semibold text-amber-100">Disclaimer:</span> This platform
        provides educational guidance and weight-adjusted baseline calculations only. It does
        not constitute professional medical advice, diagnosis, or treatment. If you are
        seriously ill, pregnant, have a chronic condition, or your symptoms worsen, please stop
        and consult a licensed medical professional.
      </p>
    </div>
  );
}
